[
    {"groupId": "1", "name": "Chad Barnes", "going": ""},
    {"groupId": "1", "name": "Katy Barnes", "going": ""},
    {"groupId": "1", "name": "Bode Barnes", "going": ""},
    {"groupId": "1", "name": "Jake Barnes", "going": ""},
    {"groupId": "1", "name": "Max Becker", "going": ""},
    {"groupId": "2", "name": "Ben Barnes", "going": ""},
    {"groupId": "2", "name": "Georgina Barnes", "going": ""},
    {"groupId": "3", "name": "Aaron Becker", "going": ""},
    {"groupId": "3", "name": "Keri Jacobs", "going": ""},
    {"groupId": "4", "name": "Kayla Becker", "going": ""},
    {"groupId": "5", "name": "Corey Becker", "going": ""},
    {"groupId": "6", "name": "Mike Becker", "going": ""},
    {"groupId": "6", "name": "Barb Becker", "going": ""},
    {"groupId": "7", "name": "Jamie Shae", "going": ""},
    {"groupId": "7", "name": "James Calhoun", "going": ""},
    {"groupId": "8", "name": "Kayla Long", "going": ""},
    {"groupId": "8", "name": "Garret Long", "going": ""},
    {"groupId": "9", "name": "Mark Kraft", "going": ""},
    {"groupId": "9", "name": "Tracey Kraft", "going": ""},
    {"groupId": "9", "name": "Eli Kraft", "going": ""},
    {"groupId": "9", "name": "Plus One", "going": ""},
    {"groupId": "10", "name": "Ina Kraft", "going": ""},
    {"groupId": "10", "name": "Madeline Kraft", "going": ""},
    {"groupId": "11", "name": "Elizabeth Williams", "going": ""},
    {"groupId": "12", "name": "Jim Williams", "going": ""},
    {"groupId": "13", "name": "Jason Williams", "going": ""},
    {"groupId": "14", "name": "Jayne Lewton", "going": ""},
    {"groupId": "14", "name": "Scot Lewton", "going": ""},
    {"groupId": "15", "name": "Jon Lewton", "going": ""},
    {"groupId": "15", "name": "Jamie Lewton", "going": ""},
    {"groupId": "16", "name": "Cody Lewton", "going": ""},
    {"groupId": "16", "name": "Kirby Lewton", "going": ""},
    {"groupId": "17", "name": "Abby Blacker", "going": ""},
    {"groupId": "17", "name": "Ryan Blacker", "going": ""},
    {"groupId": "18", "name": "John Sirianni", "going": ""},
    {"groupId": "18", "name": "Ginger Sirianni", "going": ""},
    {"groupId": "19", "name": "Deb Booth", "going": ""},
    {"groupId": "19", "name": "Ben Booth", "going": ""},
    {"groupId": "20", "name": "Mat Garwood", "going": ""},
    {"groupId": "20", "name": "Stephanie Garwood", "going": ""},
    {"groupId": "21", "name": "Corey Kleusner", "going": ""},
    {"groupId": "21", "name": "Stacey Kleusner", "going": ""},
    {"groupId": "22", "name": "Becky Lange", "going": ""},
    {"groupId": "22", "name": "Kurt Lange", "going": ""},
    {"groupId": "23", "name": "Don Schweitzer", "going": ""},
    {"groupId": "23", "name": "Terri Schweitzer", "going": ""},
    {"groupId": "24", "name": "Sydney Schweitzer", "going": ""},
    {"groupId": "24", "name": "Evan Jurgensmeier", "going": ""},
    {"groupId": "25", "name": "Gerry Schweitzer", "going": ""},
    {"groupId": "25", "name": "Tina Schweitzer", "going": ""},
    {"groupId": "26", "name": "Ryan Schweitzer", "going": ""},
    {"groupId": "26", "name": "Caroline Schweitzer", "going": ""},
    {"groupId": "27", "name": "Emily Fosse", "going": ""},
    {"groupId": "27", "name": "Sam Fosse", "going": ""},
    {"groupId": "28", "name": "Sara Schweitzer", "going": ""},
    {"groupId": "28", "name": "Avery Tilley", "going": ""},
    {"groupId": "29", "name": "Terri Gowin", "going": ""},
    {"groupId": "29", "name": "Sandy Gowin", "going": ""},
    {"groupId": "30", "name": "Laurie Fitch", "going": ""},
    {"groupId": "30", "name": "Gerry Fitch", "going": ""},
    {"groupId": "31", "name": "Carolyn Fitch", "going": ""},
    {"groupId": "31", "name": "Cam Kaskocsak", "going": ""},
    {"groupId": "32", "name": "Jim Schweitzer", "going": ""},
    {"groupId": "32", "name": "Cindy Schweitzer", "going": ""},
    {"groupId": "33", "name": "Ali Gowin", "going": ""},
    {"groupId": "34", "name": "Austin Gowin", "going": ""},
    {"groupId": "34", "name": "Shelby Gowin", "going": ""},
    {"groupId": "35", "name": "Bob Schweitzer", "going": ""},
    {"groupId": "36", "name": "Helen Schweitzer", "going": ""},
    {"groupId": "37", "name": "Kim Johnson", "going": ""},
    {"groupId": "37", "name": "JJ Johnson", "going": ""},
    {"groupId": "38", "name": "Michael Berkley", "going": ""},
    {"groupId": "38", "name": "Cassi Berkley", "going": ""},
    {"groupId": "39", "name": "Jarod Harrison", "going": ""},
    {"groupId": "39", "name": "Kai Harrison", "going": ""},
    {"groupId": "40", "name": "Jesse Bates", "going": ""},
    {"groupId": "41", "name": "Daniel Bates", "going": ""},
    {"groupId": "41", "name": "Britney Bates", "going": ""},
    {"groupId": "42", "name": "Lisa Ross", "going": ""},
    {"groupId": "42", "name": "Bob Ross", "going": ""},
    {"groupId": "43", "name": "Will Brandow", "going": ""},
    {"groupId": "43", "name": "Gina Brandow", "going": ""},
    {"groupId": "44", "name": "Seth Brandow", "going": ""},
    {"groupId": "45", "name": "Rachel Brandow", "going": ""},
    {"groupId": "45", "name": "Jordan Davis", "going": ""},
    {"groupId": "46", "name": "Justin Berkley", "going": ""},
    {"groupId": "46", "name": "Michelle Berkley", "going": ""},
    {"groupId": "46", "name": "Greyson Berkley", "going": ""},
    {"groupId": "46", "name": "Stella Berkley", "going": ""},
    {"groupId": "47", "name": "Josh Berkley", "going": ""},
    {"groupId": "47", "name": "Amanda Berkley", "going": ""},
    {"groupId": "47", "name": "Jackson Berkley", "going": ""},
    {"groupId": "47", "name": "Elery Berkley", "going": ""},
    {"groupId": "47", "name": "Plus One", "going": ""},
    {"groupId": "48", "name": "Rob Newton", "going": ""},
    {"groupId": "49", "name": "Blake Richards", "going": ""},
    {"groupId": "49", "name": "Tina Richards", "going": ""},
    {"groupId": "49", "name": "Parker Richards", "going": ""},
    {"groupId": "50", "name": "Mandi Burkett", "going": ""},
    {"groupId": "50", "name": "Ryan Burkett", "going": ""},
    {"groupId": "51", "name": "Miranda Bartusek", "going": ""},
    {"groupId": "51", "name": "Nick Bartusek", "going": ""},
    {"groupId": "52", "name": "Dick Quick", "going": ""},
    {"groupId": "53", "name": "Amy Davis", "going": ""},
    {"groupId": "53", "name": "Pat Davis", "going": ""},
    {"groupId": "54", "name": "Dave Wiese", "going": ""},
    {"groupId": "54", "name": "Leanne Wiese", "going": ""},
    {"groupId": "54", "name": "Drew Wiese", "going": ""},
    {"groupId": "54", "name": "Whitney Wiese", "going": ""},
    {"groupId": "55", "name": "Melissa Miyamura", "going": ""},
    {"groupId": "56", "name": "Shelly Wiersum", "going": ""},
    {"groupId": "56", "name": "Tom Wiersum", "going": ""},
    {"groupId": "57", "name": "Amy Gross", "going": ""},
    {"groupId": "57", "name": "Jay Gross", "going": ""},
    {"groupId": "58", "name": "Kristi Bentz", "going": ""},
    {"groupId": "58", "name": "Travis Bentz", "going": ""},
    {"groupId": "59", "name": "Rod Mestdagh", "going": ""},
    {"groupId": "59", "name": "Teresa Mestdagh", "going": ""},
    {"groupId": "60", "name": "Kevin Crawford", "going": ""},
    {"groupId": "60", "name": "Jill Crawford", "going": ""},
    {"groupId": "61", "name": "Lori Mestdagh", "going": ""},
    {"groupId": "61", "name": "Scott Beaty", "going": ""},
    {"groupId": "62", "name": "Beth Kershner", "going": ""},
    {"groupId": "63", "name": "Sidd Somayajula", "going": ""},
    {"groupId": "63", "name": "Savannah Stern", "going": ""},
    {"groupId": "64", "name": "Saketh Undurty", "going": "false"},
    {"groupId": "64", "name": "Milauni Undurty", "going": "false"},
    {"groupId": "65", "name": "Phuong Tran", "going": ""},
    {"groupId": "65", "name": "Jacob Li", "going": ""},
    {"groupId": "66", "name": "Tanvi Yenna", "going": ""},
    {"groupId": "67", "name": "Annie Howard", "going": ""},
    {"groupId": "68", "name": "Andrew Novitskiy", "going": ""},
    {"groupId": "68", "name": "Katy Novitskiy", "going": ""},
    {"groupId": "69", "name": "Calvin Senteza", "going": ""},
    {"groupId": "69", "name": "Gabby Anderson", "going": ""},
    {"groupId": "70", "name": "Joe Evans", "going": ""},
    {"groupId": "70", "name": "Vy Evans", "going": ""},
    {"groupId": "71", "name": "Calvin Pelletier", "going": ""},
    {"groupId": "72", "name": "Amanda Gibbons", "going": ""},
    {"groupId": "73", "name": "Jesse Ledbetter", "going": ""},
    {"groupId": "73", "name": "Betsy Pieper", "going": ""},
    {"groupId": "74", "name": "Brian Garrels", "going": ""},
    {"groupId": "75", "name": "Parker Reed", "going": ""},
    {"groupId": "75", "name": "Paige Mall", "going": ""},
    {"groupId": "76", "name": "Steve Maynard", "going": ""},
    {"groupId": "76", "name": "Ellen Maynard", "going": ""},
    {"groupId": "77", "name": "Cam Schneider", "going": ""},
    {"groupId": "77", "name": "Sylvia Visser", "going": ""},
    {"groupId": "78", "name": "Kaylea Cobb", "going": ""},
    {"groupId": "78", "name": "CJ Buck", "going": ""},
    {"groupId": "79", "name": "Mikey EnTin", "going": ""},
    {"groupId": "79", "name": "Kayli Nartatez", "going": ""},
    {"groupId": "80", "name": "Josh Petefish", "going": ""},
    {"groupId": "81", "name": "Sara Wodka", "going": ""},
    {"groupId": "82", "name": "Cassidy Mullins", "going": ""},
    {"groupId": "83", "name": "Alana Hillgartner", "going": ""},
    {"groupId": "83", "name": "Jules Henningsen", "going": ""},
    {"groupId": "84", "name": "Samantha Gallo", "going": ""},
    {"groupId": "85", "name": "Nick Fisher", "going": ""},
    {"groupId": "85", "name": "Alyssa Leicht", "going": ""},
    {"groupId": "86", "name": "Charlie Pattersen", "going": ""},
    {"groupId": "86", "name": "Devin Pattersen", "going": ""},
    {"groupId": "87", "name": "John Fisher", "going": ""},
    {"groupId": "87", "name": "Sara Fisher", "going": ""},
    {"groupId": "88", "name": "Ryan Garmoe", "going": ""},
    {"groupId": "88", "name": "Plus One", "going": ""},
    {"groupId": "89", "name": "Jake Bachman", "going": ""},
    {"groupId": "90", "name": "Morgan Burmester", "going": ""},
    {"groupId": "91", "name": "Greg Rudolph", "going": ""},
    {"groupId": "91", "name": "Tristin Snodgrass", "going": ""},
    {"groupId": "92", "name": "Emma Seibert", "going": ""},
    {"groupId": "92", "name": "Chase Seibert", "going": ""},
    {"groupId": "93", "name": "Becca Stephens", "going": ""},
    {"groupId": "93", "name": "Aiden McDonald", "going": ""},
    {"groupId": "94", "name": "Meredith Brown", "going": ""},
    {"groupId": "94", "name": "Plus One", "going": ""},
    {"groupId": "95", "name": "Maggie Goldhammer", "going": ""},
    {"groupId": "95", "name": "Chase Goldhammer", "going": ""},
    {"groupId": "96", "name": "Brendan Pendegraft", "going": ""},
    {"groupId": "96", "name": "Alex Pendegraft", "going": ""},
    {"groupId": "97", "name": "Sam Bates", "going": ""},
    {"groupId": "97", "name": "Lily Noonan", "going": ""},
    {"groupId": "98", "name": "Madi Delk", "going": ""},
    {"groupId": "98", "name": "Plus One", "going": ""},
    {"groupId": "99", "name": "Kathy Pingel", "going": ""},
    {"groupId": "99", "name": "Ron Zeigler", "going": ""},
    {"groupId": "100", "name": "Tommy Anderson", "going": ""},
    {"groupId": "101", "name": "Connor Bredback", "going": ""},
    {"groupId": "101", "name": "Plus One", "going": ""},
    {"groupId": "102", "name": "Claire Guderjahn", "going": ""},
    {"groupId": "103", "name": "Meredith Toebben", "going": ""},
    {"groupId": "104", "name": "Christina Docter", "going": ""},
    {"groupId": "104", "name": "Aaron Docter", "going": ""},
    {"groupId": "105", "name": "Emily Bressler", "going": ""},
    {"groupId": "106", "name": "Tyler Thompson", "going": ""},
    {"groupId": "106", "name": "Hanna McClatchey", "going": ""},
    {"groupId": "107", "name": "Addy Evans", "going": ""},
    {"groupId": "108", "name": "Travis Reinders", "going": ""},
    {"groupId": "109", "name": "Nikolina Petrovic", "going": ""},
    {"groupId": "109", "name": "Michelle Petrovic", "going": ""},
    {"groupId": "110", "name": "Chris Guttin", "going": ""},
    {"groupId": "110", "name": "Sue Guttin", "going": ""},
    {"groupId": "111", "name": "John Currier", "going": ""},
    {"groupId": "111", "name": "Renee Currier", "going": ""},
    {"groupId": "112", "name": "Gary Brazelton", "going": ""},
    {"groupId": "112", "name": "Jen Brazelton", "going": ""},
    {"groupId": "113", "name": "Dermot Hayes", "going": ""},
    {"groupId": "113", "name": "Caroline Hayes", "going": ""},
    {"groupId": "114", "name": "Steve Haun", "going": ""},
    {"groupId": "114", "name": "Monica Haun", "going": ""},
    {"groupId": "115", "name": "Beth Day", "going": ""},
    {"groupId": "115", "name": "Kevin Day", "going": ""},
    {"groupId": "116", "name": "Michael Nyamira", "going": ""}
]